<template>
  <div>
    <topbar :title="$t('maps.page-title')" />

    <div class="mx-auto max-w-3xl w-full md:px-3 xl:max-w-none xl:three-columns xl:grid">
      <div class="col-start-2" v-if="mappedWords.length">
        <div class="flex overflow-hidden bg-card rounded-full shadow-md m-3 md:mx-0 ">
          <input type="search" class="flex-1 focus:outline-none p-2 pl-3" v-model="filter" @keypress.enter="$event.target.blur()" placeholder="cerca">
          <div class="flex items-center pr-3">
            <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 45 45"><g transform="translate(-625.237 -522.802)"><path d="M598.224,655.074l-8.446-8.446a14.3,14.3,0,1,0-4.317,4.319l8.445,8.445a3.053,3.053,0,0,0,4.318-4.318ZM568.7,647.961a12.792,12.792,0,1,1,19.712-1.979c-.069.1-.141.208-.212.31q-.316.447-.67.866c-.235.278-.482.547-.738.8a12.918,12.918,0,0,1-1.672,1.41c-.1.071-.2.143-.305.211a12.8,12.8,0,0,1-16.113-1.621Zm28.459,10.369a1.552,1.552,0,0,1-2.193,0l-8.269-8.269c.037-.03.069-.065.105-.094.365-.3.719-.611,1.052-.943s.643-.687.943-1.052c.03-.036.065-.068.094-.1l8.268,8.268a1.55,1.55,0,0,1,0,2.194Z" transform="translate(66.775 -96.821)" fill="#a0a0a0"/></g></svg>
          </div>
        </div>

        <card type="square" class="flex flex-col md:rounded-lg">
          <router-link 
            class="border-b border-line px-2 py-2 flex items-center justify-between"
            v-for="word of filteredWords" 
            :key="word.word"
            :to="{name: 'MapsDetail', params: {id: word.word}}" 
          >
            <span>
              {{word.word}}
            </span>
            <span :class="word.visited ? 'text-secondary_text' : 'text-brand-1'">
              <svg xmlns="http://www.w3.org/2000/svg" width="45" height="45"><path d="M5 23.72h33.75l-8.71 8.72a.72.72 0 001.02 1.02l9.9-9.9a.88.88 0 000-1.12l-9.9-9.9a.72.72 0 00-1.02 1.02l8.71 8.71H5a.72.72 0 000 1.45z" fill="currentColor"/></svg>
            </span>
          </router-link>
        </card>

        <card title="Nessun risultato" class="" v-if="filteredWords.length === 0 && filter.trim().length > 0">
          Non hai sbloccato mappe che corrispondono alla tua ricerca.
        </card>
      </div>
      <div v-else class="col-start-2 m-3">
        <div class="hidden h-10 md:block"></div>
        <card title="Completa i sondaggi" class="max-w-lg mx-auto w-full" v-if="words.length === 0">
          Le mappe non sono ancora disponibili per te. Sbloccale rispondendo alle domande della sezione “<router-link class="text-brand-1 underline" :to="{name: 'SurveyList'}">Come lo dici?</router-link>”
        </card>
        <card title="Che velocità!" class="max-w-lg mx-auto w-full" v-else-if="mappedWords.length === 0">
          La mappa è in fase di elaborazione. Prova a riaprirla tra pochi minuti.
        </card>

      </div>
    </div>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      filter: ''
    }
  },
  computed: {
    ...mapGetters('surveys', ['words']),
    ...mapGetters("wordmaps", ["mapUrls"]),
    mappedWords() {
      if(this.words && this.mapUrls) {
        return this.words.filter(w => w.word in this.mapUrls)
      }
      return []
    },
    filteredWords() {
      const words = this.mappedWords

      const filter = this.filter.trim().toLowerCase()
      if(filter.length > 0) {
        return words.filter(w => w.word.toLowerCase().indexOf(filter) >= 0)
      } else {
        return words
      }
    }
  },
}
</script>

<style>

</style>